import PropTypes from 'prop-types';
import React from 'react';

export default class DateCell extends React.Component {

  static propTypes = {
    toggleAvailabilityView: PropTypes.func,
    date: PropTypes.number
  }

  render() {
    return (
      <div className='DayPicker-Day--wrapper' onClick={this.props.toggleAvailabilityView}>
        <div style={{ transform: 'translateY(-50%)' }}>{this.props.date}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Modules/AvailabilityCalendar/DateCell.js